module.exports = __webpack_public_path__ + "static/media/social-odnoklassniki.a403c9fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-odnoklassniki.svg
// module id = 76
// module chunks = 0